import { render, staticRenderFns } from "./ContactsModal.vue?vue&type=template&id=62162273&"
import script from "./ContactsModal.vue?vue&type=script&lang=js&"
export * from "./ContactsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports